export const isSuccess = (code) => {
  return +code >= 200 && +code <= 299
}
